import React, {useContext, useState} from 'react'
import {ListContactContext} from "./../context/ListContactContext";
import Filter from "../../../statics/assets/icons/filter.svg";
import ListContactFilters from "./filters/ListContactFilters";
import {Pagination} from "antd";
import ListCustomerTable from "./table/ListCustomerTable";
import ListContactForm from "./form/ListContactForm"
import {getLocalData, setLocalData} from "../../../services/StorageServices";
import FilterInput from "../../customers/components/filters/FilterInput";
import DeleteContactForm from "./form/DeleteContactForm";
import _checkRoles from "../../../helpers/checkRole"

function ListContactPage() {
    const ListContactPageContext = useContext(ListContactContext)
    const {
        listContact,
        total,
        page,
        limit,
        loading,
        error,
        filters,
        setFiltersState,
        setLimit,
        setPage,
        fetchListContact
    } = ListContactPageContext
    const {contactListName, showFiltersLocal = false} = filters
    const [showFilters, toggleFilters] = useState(showFiltersLocal)
    const [selectAll, setSelectAll] = useState(false)
    const [arrSelected, setArrSelected] = useState([])

    const _toggleShowFilter = () => {
        const listContactFilters = getLocalData('listContactFilters') || {}
        setLocalData('listContactFilters', {...listContactFilters, showFiltersLocal: !showFilters})
        toggleFilters(!showFilters)
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target
        setFiltersState({
            ...filters,
            [name]: value
        })
    }

    const _onChangePagination = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _handleCheckALl = (isChecked) => {
        if (isChecked) {
            const selectedLead = listContact.map(itemL => itemL.contactListId)
            setArrSelected(selectedLead)
            setSelectAll(true)
        } else {
            setArrSelected([])
            setSelectAll(false)
        }
    }

    const _handleClearChecked = () => {
        setArrSelected([])
        setSelectAll(false)
    }

    const _updateSelected = (id, isAdded) => {
        if (isAdded && !arrSelected.includes(id)) {
            setArrSelected([...arrSelected, id])
            setSelectAll(arrSelected.length + 1 === listContact.length)
        } else {
            const filtered = arrSelected.filter(item => item !== id)
            setArrSelected(filtered)
            setSelectAll(false)
        }
    }

    return <div className='ListCustomerPage PageDefault position-relative'>
        <div className="PageHeading">
            <h1 className="PageTitle">Danh sách Contact</h1>
            <div className="d-flex align-items-center PageFilterTop">
                <div className={`Filter mr-3 ${showFilters && 'filtersOpen'}`}>
                    <label onClick={_toggleShowFilter}><Filter width={20} height={20}/>Bộ lọc</label>
                </div>
                <FilterInput
                    label=""
                    name="contactListName"
                    placeholder="Tên danh sách"
                    value={contactListName}
                    onChangeInput={_handleChangeInput}
                />
                <ListContactForm/>
                {(_checkRoles('campaign.contact.list.Del') && arrSelected.length > 0) &&
                    <DeleteContactForm arrSelected={arrSelected} fetchListContact={fetchListContact}
                                       onClearChecked={_handleClearChecked}/>}
            </div>
        </div>
        {showFilters && <ListContactFilters filters={filters} setFiltersState={setFiltersState}/>}
        <div className="PageTable">
            <ListCustomerTable loading={loading} error={error} listContact={listContact}
                               selectAll={selectAll}
                               arrSelected={arrSelected}
                               onCheckALl={_handleCheckALl}
                               onSelected={_updateSelected}/>
            <div className="PagePagination">
                <Pagination
                    className="PaginationCustom"
                    total={total}
                    pageSize={limit}
                    current={page}
                    onChange={_onChangePagination}
                />
            </div>
        </div>
    </div>
}

export default ListContactPage
